<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'
import { Button } from './components/ui'
import ToastHost from './components/ToastHost.vue'

const renderError = ref<Error | null>(null)

onErrorCaptured((err) => {
  console.error('后台渲染异常', err)
  renderError.value = err instanceof Error ? err : new Error(String(err))
  return false
})

function reload() {
  window.location.reload()
}
</script>

<template>
  <div
    v-if="renderError"
    class="mx-auto flex max-w-lg flex-col items-center gap-3 px-6 py-24 text-center"
  >
    <h1 class="text-[16px] font-semibold">界面出错了</h1>
    <p class="font-mono text-[12px] break-all text-danger">{{ renderError.message }}</p>
    <Button @click="reload">重新加载</Button>
  </div>
  <template v-else>
    <RouterView />
    <ToastHost />
  </template>
</template>
